import React,{Component} from 'react';
import { Link } from 'react-router';
import $ from 'jquery';
import Footer from './../Common/footer';
import Swiper from 'react-id-swiper';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

class BrowseFeedDeals extends Component{
  constructor(props){
    super(props);
    this.state={
        feed_cat: [],
        feed_sub_cat: [],
        feed_brands: [],
        details: '',
        offer: '',
        type: this.props.params.Type,
        prevPath: '',
        loading: false,
        seo_title:'',
        seo_desc:'',
        deal_count:'',
        brand_count:'',
        category_status:0,
        cart_count:0,

        total_feed_brands:[],
        isToggle:true,
        brand_id:'',
        sort_deal_count:'',
    };
    this.getDeviceId=this.getDeviceId.bind(this);
    this.getswipe_Brands=this.getswipe_Brands.bind(this);
    this.getCartCount=this.getCartCount.bind(this);
  }
  componentWillReceiveProps(nextProps)
  {
    if(nextProps.location !== this.props.location) 
    {
        this.setState({
          prevPath: this.props.location
        });
    }
  }
  getCartCount()
  {
      if(localStorage.user_id)
      {
        var uid = localStorage.user_id;
      }
      else
      {
         uid =0;
      }
	    var data1={from: 'mobile_web',id:uid,token:localStorage.getItem('token')};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'cart_count',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
              this.setState({
	                cart_count:data.cart_count,
	            });
	          }.bind(this),
	          error: function(err){
	          
	          }
	    }) 
  }
  componentDidMount()
  {

    if(screen.width >= 800 )
    {
      window.location.href="/web/pdeals/"+this.props.params.BrandName+"/all/"+this.props.params.Type;
    }
    if(localStorage.user_id && localStorage.token)
    {
      this.getCartCount();
    }
    this.getDeviceId();
    // localStorage.setItem('cat_id',0);
    localStorage.removeItem('cat_id');
    localStorage.removeItem('cat');
    localStorage.removeItem('url');
    localStorage.removeItem('cat_sort');
    localStorage.removeItem('m_r_p_deals');
    localStorage.setItem('cat_page',this.props.params.Type);
    // localStorage.setItem('currPath',this.props.location.pathname);
    var uid =0;
    if(localStorage.user_id)
    {
      uid=localStorage.getItem('user_id');
    }
    else
    {
      uid=0;
    }

    var data1={from: 'mobile_web',uid:uid,type:this.state.type};
    var data2=JSON.stringify(data1);
    $.ajax({
          method: 'POST',
          url: baseUrl+'getbrands_categoires',
          dataType:'json',
          data: {req:data2},
          success: function(data)
          {
            this.setState({
                loading: true,
                feed_cat:data.categories,
                // feed_brands:data.brands,
                total_feed_brands:data.brands,
                offer: data,
                type: this.props.params.Type,
                deal_count: data.deal_count,
            });
            if(this.props.params.Type==="2")
            {
                document.title="Buy Aqua Feed Products Online | AquaDeals";
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.Type==="4")
            {
                document.title="Buy Aqua Healthcare Products Online | AquaDeals"; 
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Healthcare Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.Type==="3")
            {   document.title="Buy Aqua Machinery & Equipment Products Online | AquaDeals";
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Machinery & Equipment deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.Type==="5")
            {   document.title="Buy Aqua Hatchery Machinery Products Online | AquaDeals";
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Hatchery Machinery Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.Type==="7")
            {  
                document.title="Buy Aqua Hatchery Health Care Product deals Online | AquaDeals";
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Hatchery Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else {
             document.title="Buy Aquaculture deals Online | AquaDeals";
             document.getElementsByTagName("META")[2].content="Browse quality Aquaculture deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
          }.bind(this),
          error: function(err){
          
          }
    })
  }
  getDeviceId()
  {
    if(localStorage.user_id)
    {
        var user_id=localStorage.user_id;
    }
    else
    {
      user_id=0;
    }
    var data1={from: 'mobile_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
    var data2=JSON.stringify(data1);

    $.ajax({
        method: 'POST',
        url: baseUrl+'getDeviceId',
        dataType: 'json',
        data:{req: data2},
        success: function(data){

        },
        error: function(err){
        }
    });
  }  
  getTitle()
  {
    if(this.state.type==='2')
    {
      return "Feed";
    }
    else if (this.state.type === '3')
    {
      return "Machinery & Farm Equipments";
    }
    else if(this.state.type === '4')
    {
      return "Health Care";
    }
    else if(this.state.type === '5')
    {
      return "Hatchery Machinery";
    }
    else if(this.state.type === '7')
    {
      return "Hatchery Health Care";
    }
  }
  getswipe_Brands(x,url_dtype_name,url_name,type,dtype)
  {
    localStorage.setItem('cat_id',x);
    localStorage.setItem('url','/pdeals/'+url_dtype_name+'/'+url_name+'/'+x+'/'+type+'/'+dtype)
    this.setState({
        category_status: x,
    });
    if(localStorage.user_id)
    {
        var user_id=localStorage.user_id;
    }
    else
    {
      user_id=0;
    }
    var data1={from: 'mobile_web',id: user_id,cat_id:x,type:this.state.type}
    var data2=JSON.stringify(data1);
    $.ajax({
        method: 'POST',
        url: baseUrl+'getbrandsBycat',
        dataType: 'json',
        data:{req: data2},
        success: function(data)
        {
          if(data.status==='success')
          {
              if(this.state.brand_id !== x)
              {
                this.setState({isToggle:false});
              }
              else
              {
                this.setState({isToggle:!this.state.isToggle});
                if(this.state.isToggle)
                {
                  localStorage.removeItem('url');  
                }
              }
              this.setState({
                feed_brands:data.brands,
                // deal_count:data.deal_count,
                sort_deal_count:data.deal_count,
                brand_count: data.brand_count,
                brand_id:x,
              });
          }
        }.bind(this),
        error: function(err){
          
        }
    });
  }
  render(){
    const params = {
      paginationClickable: true,
      spaceBetween: 30,
      slidesPerView: 3
    }
    
    var title = this.getTitle();
    // document.title =title + " - Deals | AquaDeals ";
    // document.getElementsByTagName("META")[2].content="Browse best deals,Aquaculture products from various brands and categories in "+title+".Contact customer care for any queries on these Aqua products and order online";
    if(this.props.params.Type==="2")
    {
      document.title="Buy Aqua Feed Products Online | AquaDeals";
      document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
    }
    else if(this.props.params.Type==="4")
    {
      document.title="Buy Aqua Healthcare Products Online | AquaDeals"; 
      document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Healthcare Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
    }
    else if(this.props.params.Type==="3")
    { 
      document.title="Buy Aqua Machinery & Equipment Products Online | AquaDeals";
      document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Machinery & Equipment Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
    }
    else if(this.props.params.Type==="5")
    {   
      document.title="Buy Aqua Hatchery Machinery Products Online | AquaDeals";
      document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Hatchery Machinery Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
    }
    else if(this.props.params.Type==="7")
    {  
      document.title="Buy Aqua Hatchery Healthcare Product deals Online | AquaDeals";
      document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Hatchery Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
    }
    else {
      document.title="Buy deals Online | AquaDeals";
      document.getElementsByTagName("META")[2].content="Browse quality Aquaculture deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
    }

    if(this.state.isToggle)
    {
      var feed_brands = this.state.total_feed_brands;
    }
    else
    {
        feed_brands =this.state.feed_brands;
    }           
    var brands=feed_brands.map(function(brand,index){
        return(
              <div className="col-sm-4 col-xs-4 col-md-4 col-lg-4 brand_section">
                <Link to={"/pdeals/"+brand.url_dtype_name+"/"+brand.url_name+"/"+brand.id +"/"+brand.type+"/"+localStorage.getItem('cat_page')}>
                  <img src={brand.logo ==="noimage.jpg" || brand.logo==="" ? baseAssets+'images/seller_imgs/thumbnails/noImage.png' : baseAssets+'images/brand_icons/'+brand.logo}  role="presentation" width='50px' alt=" "/><p className="sw_brnd_name">{brand.category_name}</p></Link>
              </div>
         )
       }) ;

    var swipe_categoies = this.state.feed_cat.map(function(cat,index){
        if(cat.sub.length >0)
          {
            var sw_subs_cat = cat.sub.map(function(sub_cat,index){
            return(
                <li>
                <Link className="swipe_cat_lst_grd swiper-slide" onClick={()=>{this.getswipe_Brands(sub_cat.id,sub_cat.url_dtype_name,sub_cat.url_name,sub_cat.type,sub_cat.dtype)}}>
                   <div style={{textAlign:'center'}}> 
                    {/* <Link to={"/pdeals/"+sub_cat.url_dtype_name+"/"+sub_cat.url_name+"/"+sub_cat.id +"/"+sub_cat.type+"/"+localStorage.getItem('cat_page')} > */}
                      <img src={baseAssets+'images/icons2/'+sub_cat.logo}  role="presentation" width='40px' height="40px" alt=" "/>
                      <div>
                        <h6 className={this.state.category_status === sub_cat.id && !this.state.isToggle ? "sw_cat_name sw_cat_name_active" : "sw_cat_name"}>
                          {sub_cat.category_name}
                        </h6>
                      {this.state.category_status === sub_cat.id && !this.state.isToggle ? <img src={baseAssets+'icons/web_icons/triangle_up.png'} alt=" " style={{width:'20px',height:'18px'}} /> : <div className="clr">&nbsp;</div>}
                      </div>
                    {/* </Link>*/}
                  </div>
                </Link>
                </li>
                )
            }.bind(this));
        }
        return(
          <li>
              <Link className={sw_subs_cat ? "swipe_cat_lst_grd swipe_cat_lst_grd_empty" : "swipe_cat_lst_grd"} onClick={sw_subs_cat ? '' : ()=>{this.getswipe_Brands(cat.id,cat.url_dtype_name,cat.url_name,cat.type,cat.dtype)}}>
                {sw_subs_cat ? '' : <div style={{textAlign:'center'}}>
                  <img src={baseAssets+'images/icons2/'+cat.logo} alt=" " role="presentation" width="40px" height="40px"/>
                    <div>
                      <h6 className={this.state.category_status === cat.id && !this.state.isToggle ? "sw_cat_name sw_cat_name_active" : "sw_cat_name"}>{cat.category_name}</h6>
                      {this.state.category_status === cat.id && !this.state.isToggle ? <img src={baseAssets+'icons/web_icons/triangle_up.png'} alt=" " style={{width:'20px',height:'18px'}} /> : <div className="clr">&nbsp;</div>}
                    </div>
                </div>

              }
                {sw_subs_cat}
              </Link>
          </li>    
        );
    }.bind(this));    
      return (
        <div className="mob_deals browse_deals_page">
          {this.state.loading ? 
            <div className="mob_deals mob_browse_deals_page">
                <div className="page_hdr">
                    <div className="container-fluid">
                       <h5 className="m_nav_back"><Link to={"/"}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link><span className="header_text">{title}</span></h5>
                       <a href="/" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
                       <a className="mob_cart_btn" href="/mycart">
                          <img alt=" " src={baseAssets+'icons/web_icons/cart_icon.png'} />
                          {this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"}>{this.state.cart_count}</span> : ''}
                       </a>
                    </div>
                </div>
                <div className="pag_cntnt browse_feed1">
                  <div className="container-fluid">
                      <div className="sw_cat_blk">
                          {swipe_categoies.length >0 ? <h2 className="mob_swip_hdg" style={{color:'#333'}}>CATEGORIES</h2> : <div className="no_data">
                            <h3>No Products Available</h3>
                            <p><Link to={"/customer_care"}>CONTACT US</Link></p>
                            {/*<p>Need something here? <Link to={"/customer_care"}>CONTACT US</Link> now !</p>*/}
                          </div>
                          }
                          <div>
                            <ul className="mob_browse_cat_container">
                              {swipe_categoies}
                            </ul>
                          </div>
                      </div>
                      <div className="clr"></div>
                      <div className="sw_brands_blk">
                       {localStorage.url ? 
                          <div className="browse_cat_brands">
                             {brands.length > 0 ? <div className="col-md-4 col-xs-4 col-sm-4" style={{padding:'0px'}}>BRANDS : {brands.length}</div>  : ''}
                             <div className="col-md-4 col-xs-4 col-sm-4 txt_cnt">{this.state.isToggle ? "Items : "+ this.state.deal_count : "ITEMS : "+this.state.sort_deal_count}</div>
                             {!this.state.isToggle?
                               <div className="col-md-4 col-xs-4 col-sm-4" style={{padding:'0px',textAlign:'right'}}>{localStorage.url ? <Link className="mob_view_all_deals" to={localStorage.getItem('url')} >VIEW ALL DEALS</Link> : ''}</div>
                              :''}
                          </div>
                          :
                          <div>
                            {brands.length > 0 ? <div className="browse_cat_brands2">
                               {brands.length > 0 ? <div className="col-md-6 col-xs-6 col-sm-6" style={{padding:'0px'}}>BRANDS : {brands.length}</div> : ''}
                               <div className="col-md-6 col-xs-6 col-sm-6" style={{padding:'0px',textAlign:'right'}}>{this.state.isToggle ? "ITEMS : "+ this.state.deal_count :"ITEMS : "+ this.state.sort_deal_count}</div>
                            </div> : ''}
                            </div>
                        }
                          <div className="row brands_container">{brands}</div>
                      </div>
                      <div className="clr">&nbsp;</div>
                  </div>
                </div>
            </div> : 
            <div className="mob_loading">
                <img src={baseAssets+'images/web_imgs/mob_loading.gif'} alt="Loading" role="presentation"/> 
            </div>
          }
          {/*<Footer />*/}
        </div>
    );
  }
}
export default BrowseFeedDeals;



/** WEBPACK FOOTER **
 ** ./src/components/Categories/Feed/Browse_feed_deals.js
 **/